import moment from 'moment';
import Vue from 'vue'

const state = {
  selectedSchedule: null,
  schedule: null,
  selectedWeek: "1",
  selectedYear: "2019",
  copiedWeek: {},
}

const mutations = {
  RESET_SCHEDULES: function (state) {
    state.schedule = null;
    state.selectedSchedule = null;
  },
  SET_SCHEDULES: function (state, schedule) {
    state.schedule = schedule;
  },
  SET_SELECTED_SCHEDULE: function (state, scheduleId) {
    state.selectedSchedule = scheduleId;
  },
  SET_SELECTED_WEEK: function (state, weekNum) {
    state.selectedWeek = weekNum;
  },
  SET_SELECTED_YEAR: function (state, year) {
    state.selectedYear = year.toString();
  },
  ADD_CLASS_TO_WEEK: function (state, data) {

    // Check if the week is a an array and replace it for an object
    if (Array.isArray(state.schedule[state.selectedWeek])) {
      state.schedule[state.selectedWeek] = {};
    }

    //Create new week if it doesn't exist
    if (state.schedule[state.selectedWeek] == undefined) {
      state.schedule[state.selectedWeek] = {};
    }

    //Create new day object if it doesnt exist
    if (state.schedule[state.selectedWeek][data.day] == undefined) {
      state.schedule[state.selectedWeek][data.day] = [];
      state.schedule[state.selectedWeek][data.day].push(data.class);
      console.log("A");
    }
    //Add item to day if day exists and there's no class with same starting time
    else if (state.schedule[state.selectedWeek][data.day].findIndex(c => {
      return c.time == data.class.time
    }) == -1) {
      console.log(state.schedule);
      state.schedule[state.selectedWeek][data.day].push(data.class);
    }

    //For rendering
    /* let idx = state.schedules.findIndex(sc => {
      return sc.id == scheduleObj.id
    }) */
    //state.schedule.splice(idx, 1, scheduleObj)
    state.schedule = Object.assign({}, state.schedule)
  },
  REPLACE_CLASS_IN_DAY: function (state, data) {

    /* let scheduleObj = state.schedules.find(sc => {
      return sc.id == state.selectedSchedule
    })
 */

    if (state.schedule[state.selectedWeek][data.day] === undefined) {
      state.schedule[state.selectedWeek][data.day] = [];
      state.schedule[state.selectedWeek][data.day].push(data.class);
    }
    else {
      let idx = state.schedule[state.selectedWeek][data.day].findIndex((item) => {
        return item.time === data.class.time;
      })
      state.schedule[state.selectedWeek][data.day].splice(idx, 1, data.class);
    }
  },
  REMOVE_CLASS_FROM_WEEK: function (state, data) {

    /* let scheduleObj = state.schedules.find(sc => {
      return sc.id == state.selectedSchedule
    })
 */
    let idx = state.schedule[state.selectedWeek][data.day].findIndex((item) => {
      return item.time === data.class.time;
    })
    state.schedule[state.selectedWeek][data.day].splice(idx, 1);
  },
  SET_WEEK_TO_COPY: function (state, week) {
    state.copiedWeek = week;
  },
  COPY_FROM_WEEK_TO_WEEK: function (state, weekToCopy) {

    /* //Get selected schedule
    let scheduleObj = state.schedules.find(sc => {
      return sc.id == state.selectedSchedule
    }) */

    //Have to parse and then assign to make new week unique - Vue.use is used for adding reactivity
    // Vue.set(state.schedule, state.selectedWeek, JSON.parse(JSON.stringify(state.schedule[weekToCopy])));
    Vue.set(state.schedule, state.selectedWeek, JSON.parse(JSON.stringify(state.copiedWeek)));
  },
  CLEAR_WEEK: function (state, week) {
    state.schedule[state.selectedWeek] = {};
    state.schedule = Object.assign({}, state.schedule)
  }
}

const actions = {
  setWeekToCopy({ commit, state }, weekToCopy) {

    commit('SET_WEEK_TO_COPY', state.schedule[weekToCopy])
  },
  initializeSchedules({ commit, rootState }) {
    let s = []
    rootState.Database.db
      .collection("schedules")
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          //console.log(doc.id, " => ", doc.data());
          let data = doc.data();
          data['id'] = doc.id;
          s.push(data);
        });
        commit('SET_SCHEDULES', s);
      });
  },
  downloadSchedule({ dispatch, commit, rootState }) {
    let s = []
    dispatch('setMessage', "Downloading schedule...");
    rootState.Database.db
      .collection("schedules")
      .doc(state.selectedSchedule)
      .collection("schedule")
      .doc(state.selectedYear)
      .get()
      .then(function (doc) {
        if (doc.exists) {
          commit('SET_SCHEDULES', doc.data());
        }
        else {
          commit('SET_SCHEDULES', {});
        }
        dispatch('clearMessage');
      });

  },
  clearWeek({ dispatch, commit, state }) {
    commit('CLEAR_WEEK')
  },
  changeSelectedSchedule({ dispatch, commit, state }, scheduleId) {
    commit('SET_SELECTED_SCHEDULE', scheduleId)
    dispatch('downloadSchedule');
  },
  changeSelectedWeek({ commit, state }, weekNum) {
    commit('SET_SELECTED_WEEK', weekNum.toString())
  },
  changeSelectedYear({ dispatch, commit, state }, year) {
    commit('SET_SELECTED_YEAR', year)
    dispatch('downloadSchedule');
  },
  addClassToWeek({ commit, state }, data) {
    commit('ADD_CLASS_TO_WEEK', data)
  },
  replaceClassInDay({ commit, state }, data) {
    commit('REPLACE_CLASS_IN_DAY', data)
  },
  removeClassFromWeek({ commit, state }, data) {
    commit('REMOVE_CLASS_FROM_WEEK', data)
  },
  copyFromWeekToWeek({ commit, state }, data) {
    commit('COPY_FROM_WEEK_TO_WEEK', data)
  },
  saveSchedule({ dispatch, commit, state }, data) {

    /* let scheduleObj = state.schedules.find(sc => {
      return sc.id == state.selectedSchedule
    }) */
    /* state.name = data.name;
 */
    /* let idx = state.schedules.findIndex(sc => {
      return sc.id == scheduleObj.id
    })
    state.schedules.splice(idx, 1, scheduleObj) */
    dispatch('setMessage', "Saving schedule");
    let docRef = this.state.Database.db.collection("schedules").doc(state.selectedSchedule).collection("schedule").doc(state.selectedYear);
    docRef.set(state.schedule)
      .then(function () {
        /* console.log("Document successfully updated!"); */
        dispatch('clearMessage');
      })
      .catch(function (error) {

        console.error("Error updating document: ", error);
      });
  },


}

const getters = {
  getSchedule(state) {
    if (state.schedule !== null) {
      return state.schedule
    }
    else {
      return []
    }

  },
  getSelectedSchedule(state) {
    if (state.schedule !== null) {
      return state.schedule
    }
    else {
      return []
    }
  },
  getSelectedScheduleId(state) {
    if (state.selectedSchedule !== null) {
      return state.selectedSchedule
    }
    else {
      return null
    }
  },
  getSelectedWeek(state) {
    if (state.selectedSchedule !== null && state.schedule !== null) {
      /* let s = state.schedules.find(item => {
        return item.id == state.selectedSchedule;
      }) */
      /* 
            if (state.schedule === null) {
              state.schedule = {};
            } */

      if (state.schedule[state.selectedWeek] === undefined) {
        /* s.schedule[state.selectedWeek] = {
          mon: [],
          tue: [],
          wed: [],
          thu: [],
          fri: [],
          sat: [],
          sun: []
        } */
        return null
      }
      else {
        // SORT
        let days = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
        for (let i = 0; i < days.length; i++) {
          if (state.schedule[state.selectedWeek][days[i]] !== undefined && state.schedule[state.selectedWeek][days[i]].length > 1) {
            state.schedule[state.selectedWeek][days[i]].sort(
              function (a, b) {
                if (a.time < b.time) {
                  return -1;
                }
                if (a.time > b.time) {
                  return 1;
                }
                return 0;
              }
            );
          }
        }

      }

      return state.schedule[state.selectedWeek]
    }
    else {
      return [];
    }


  },
  /*  getSortedWeek(state) {
 
     if (state.calendar[state.selectedWeek] == undefined) {
       return [];
     }
     else {
       for (const key of Object.keys(state.calendar[state.selectedWeek])) {
         state.calendar[state.selectedWeek][key].sort(function (a, b) {
           if (a.time < b.time) {
             return -1;
           }
           if (a.time > b.time) {
             return 1;
           }
           // a must be equal to b
           return 0;
         });
       }
       return state.calendar[state.selectedWeek]
     }
   } */
}

export default {
  state,
  getters,
  actions,
  mutations
} 



// WEBPACK FOOTER //
// ./src/store/modules/Schedules.js